import Box_management_detail from "./box_management_detail";
import Box_management_listing from "./box_management_listing";

const BoxManagement = {
  BoxManagementListing: Box_management_listing,
  BoxManagementDetail: Box_management_detail,
};

export default BoxManagement;
